import React from 'react';
export var useBEM = function (blockName) { return [
    blockName,
    function (modifierName) { return blockName + "--" + modifierName; },
    function (elementName) { return useBEM(blockName + "__" + elementName); },
]; };
/**
 * Переопределяет идентификатор контейнера куда будет отображаться содержимое всех компонентов созданных через createPortal
 */
var defaultContextValue = {
    applicationElementID: 'root',
    rootElement: undefined,
};
export var PopupsContext = React.createContext(defaultContextValue);
